import Immutable from 'seamless-immutable';
import { createActions, createReducer } from 'reduxsauce';
// import Cookies from 'js-cookie';

const INITIAL_STATE = Immutable({
  user: null,
  loading: true,
  lang: 'en',
  isUser: 0,
  timeStart: null,
  timeEnd: null,
});
export const StartupSelectors = {
  user: (state) => state.startup.user,
  loading: (state) => state.startup.loading,
};

/* ------------- Types and Action Creators ------------- */
export const { Types: StartupActionsType, Creators: StartupActions } =
  createActions({
    startup: [],
    setUser: ['user'],
    request: [],
    success: [],
  });

const startup = (state) =>
  state.merge({
    logged: null,
  });

const setUser = (state, { user }) => {
  return state.merge({
    user,
  });
};

const request = (state) =>
  state.merge({
    loading: true,
  });

const success = (state) =>
  state.merge({
    loading: false,
  });

const HANDLERS = {
  [StartupActionsType.STARTUP]: startup,
  [StartupActionsType.SET_USER]: setUser,
  [StartupActionsType.REQUEST]: request,
  [StartupActionsType.SUCCESS]: success,
};

export default createReducer(INITIAL_STATE, HANDLERS);
